/**
 * External Dependencies
 */

import 'jquery';
// import initDarkmode from './modules/darkmode';
import header from './components/header';
import videoImage from './components/videoImage';
import carsCarousel from './components/carsCarousel';
import hero from './components/hero';
import imagesCarousel from './components/imagesCarousel';
import contactPopup from './components/contactPopup';
import carColorPicker from './components/carColorPicker';
import trailer from './components/trailer';

import filters from './vue/helper/Filters';
import mitt from 'mitt';
import { createApp } from 'vue';

import ComplexCalculator from './vue/components/ComplexCalculator.vue';
import FinancialCalculator from './vue/components/FinancialCalculator.vue';
import FinancialCalculatorOutput from './vue/components/FinancialCalculatorOutput.vue';

import CampaignCar from './vue/components/CampaignCar.vue';
import UsedCar from './vue/components/UsedCar.vue';
import UsedCars from './vue/components/UsedCars.vue';

import AjaxCart from './woocommerce/ajax-cart';
import MiniCart from './woocommerce/mini-cart';

import SingleProduct from './woocommerce/single-product';

const app = createApp({});
const emitter = mitt();
app.config.globalProperties.emitter = emitter;
app.config.globalProperties.$filters = filters;

app
  .component('complex-calculator', ComplexCalculator)
  .component('financial-calculator', FinancialCalculator)
  .component('financial-calculator-output', FinancialCalculatorOutput)
  .component('campaign-car', CampaignCar)
  .component('used-car', UsedCar)
  .component('used-cars', UsedCars);

app.config.compilerOptions.isCustomElement = (tag) => {
  return tag.startsWith('tacdis-');
};

if (jQuery('#app').length > 0) {
  app.mount('#app');
}

$(() => {
  // initDarkmode();
  header();
  videoImage();
  carsCarousel();
  hero();
  imagesCarousel();
  contactPopup();
  carColorPicker();
  trailer();

  AjaxCart.init();
  MiniCart.init();
  SingleProduct.init();
});
